import Component from '@glimmer/component';
import { iosAppUrl, androidAppUrl } from 'mewe/constants';

export default class MwHomeContentHeaderAvalanche extends Component {
  iosAppUrlConst = iosAppUrl;
  androidAppUrlConst = androidAppUrl;
}
